// Angular
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
// State
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../state/app.state';
import {AppVersion} from '../../model/config-file.model';
import { AppInformationService } from '../../service/app-info.service';
// Others
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { AppStateModel } from '../../model/app.state.model';

@Component({
	selector: 'cv-version-label',
	templateUrl: './version-label.component.html',
	styleUrls: ['./version-label.component.scss']
})
export class VersionLabelComponent implements OnInit, OnDestroy {
	app$: Observable<AppStateModel> = this.store.select(AppState.getAppState); 
	private atComponentDestroy = new Subject();

	@Input() showSubmodules = true;

	public today: number = Date.now();
	public lastCommitDate: any;
	public appVersion: AppVersion = null;

	public showVersioning = false;
	public modules: any = [];

	constructor(
		private  router: Router, 
		private appInfo: AppInformationService,
		private store: Store) {
	}

	ngOnInit(): void {
		this.app$.pipe(takeUntil(this.atComponentDestroy)).subscribe((app: AppStateModel) => {
			const appVersion = app[this.appInfo.appName].version;
			if (appVersion && appVersion !== null && ['sandbox', 'develop', 'test'].indexOf(appVersion.environment) > -1) {
				this.appVersion = appVersion;
				this.modules = [];
				if (this.appVersion.modules) {
					for (const [key, value] of Object.entries(this.appVersion.modules)) {
						this.modules.push({name: key, version: value});
					}
				}
				this.lastCommitDate = new Date(parseInt(this.appVersion.committedOn, 0) * 1000);
			}
		});
	}

	/**
	 * Calculate the position to open the tooltip
	 * @param event
	 */
	public onOpeningVersions(event: any): void {
		this.showVersioning = !this.showVersioning;
	}

	/**
	 * Open the System Info Page
	 * @param event
	 */
	public openSystemInfo(event: any): void {
		window.location.href = 'system-info';
	}

	/**
	 * Close all when the element is destroyed
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
